import { ErrorBoundary } from '@genial/components';
import { Spacing } from '@genial/design-tokens';
import { RouteProp, useRoute } from '@react-navigation/native';
import { Box } from 'native-base';
import React, { useEffect } from 'react';

import { SignedOutRootStackParamList } from '../../routes/types';
import { useBatchTicketInvestLinkActions } from '../../store/batchTicketInvestLink/action';

import { CustomerOffers } from './components/CustomerOffers';
import { ValidateToken } from './components/ValidateToken';
import { useAuthenticationCustomer } from './hooks/AuthenticationCustomer';

export const BatchTicketInvestLink = () => {
  const route = useRoute<RouteProp<SignedOutRootStackParamList, 'BatchTicketInvestLink'>>();
  const urlParams = new URLSearchParams(window.location.search);
  const customerOrderId = urlParams.get('cbid') || route.params?.cbid || '';

  const { addCustomerOrderId } = useBatchTicketInvestLinkActions();
  const {
    isValidatedToken,
    errorValidateToken,
    handleValidateToken,
    loadingToken,
    isExpiredToken,
  } = useAuthenticationCustomer();

  useEffect(() => {
    if (customerOrderId) {
      addCustomerOrderId(customerOrderId);
    }
  }, [addCustomerOrderId, customerOrderId]);

  if (isExpiredToken) {
    return (
      <Box px={Spacing['inline.xxs']} paddingTop={Spacing['stack.xxxl']}>
        <ErrorBoundary
          errorIconOrIllustration="WarningIllustration"
          errorTitle="Opa! este link expirou"
          errorMessage="Entre em contato seu assessor  para tirar dúvidas ou conferir novas oportunidades."
        />
      </Box>
    );
  }

  return isValidatedToken ? (
    <CustomerOffers />
  ) : (
    <ValidateToken
      errorValidateToken={errorValidateToken}
      handleValidateToken={handleValidateToken}
      loadingToken={loadingToken}
    />
  );
};
